export default __webpack_public_path__ + "static/02-02-teach-feedback-eea3503a826cfa9195328e9cd6a7641c.gif";